import type { Dispatch, ReactElement, ReactNode, SetStateAction } from 'react';

import type { ConnectDragPreview, ConnectDragSource } from 'react-dnd';

import Dots from '@/assets/svg/dragDots.svg?react';

import {
  BlockConditionContainer,
  LeftSide,
  RightSideCondition
} from '../blockBase.style';
import { BlockBody, EndControlsContainer } from '../body.block.style';

type Props = {
  isDragging: boolean;
  isCollapsed: boolean;
  isNested: boolean;
  isCondition: boolean;
  preview: ConnectDragPreview;
  drag: ConnectDragSource;
  setHover: Dispatch<SetStateAction<boolean>>;
  isHovering: boolean;
  children: ReactNode;
  EndControls?: ReactElement;
};

const BlockCondition = ({
  isDragging,
  isCollapsed,
  isNested,
  isCondition,
  preview,
  drag,
  setHover,
  isHovering,
  EndControls,
  children
}: Props) => (
  <BlockConditionContainer
    $isCollapsed={isCollapsed}
    $isDragging={isDragging}
    $isNested={isNested}
    data-tag="Condition-block"
    onMouseEnter={() => setHover(true)}
    onMouseLeave={() => setHover(false)}
    ref={preview}
  >
    <LeftSide $isCondition={isCondition} data-tag="drag-dots" ref={drag}>
      <div className="flex h-[25px] w-full shrink-0 items-center justify-center">
        <Dots className="h-5" />
      </div>
    </LeftSide>
    <RightSideCondition>
      <section className="flex w-full flex-col justify-between gap-4">
        <BlockBody>{children}</BlockBody>
      </section>
      <EndControlsContainer $isCondition={isCondition}>
        {EndControls && (
          <EndControls.type {...EndControls.props} isHovering={isHovering} />
        )}
      </EndControlsContainer>
    </RightSideCondition>
  </BlockConditionContainer>
);

export default BlockCondition;
